import { useSearch } from "@tanstack/react-router";
import { useEffect, useState } from "react";

import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";
import type { ExploreSearchParams } from "@/routes/explore/index";

import { CheckmarkIcon } from "./icons";

export default function HalloweenFilter() {
  const search = useSearch({ strict: false }) as ExploreSearchParams;
  const [isChecked, setIsChecked] = useState(search.is_scary === "Yes");

  useEffect(() => {
    setIsChecked(search.is_scary === "Yes");
  }, [search.is_scary]);

  return (
    <Label>
      <Input
        checked={isChecked}
        className="hidden"
        name="is_scary"
        onChange={(e) => setIsChecked(e.target.checked)}
        type="checkbox"
        value="Yes"
      />
      <span
        className={cn(
          "relative flex h-7.5 items-center justify-center overflow-hidden rounded-[15px] bg-linear-54 from-bronze to-golden-yellow",
          'after:absolute after:inset-0 after:bg-linear-54 after:from-bronze after:to-neon-orange after:opacity-0 after:transition-opacity after:content-[""]',
          "hover:after:opacity-100"
        )}
      >
        <span className="absolute top-2 left-2.5 z-1 flex size-3.5 items-center justify-center rounded-[2px] bg-space-gray-dark">
          <CheckmarkIcon
            className={cn("transition-opacity", !isChecked && "opacity-0")}
          />
        </span>
        <span className="relative z-1 pl-6 font-medium text-14 text-white">
          Happy Halloween
        </span>
      </span>
    </Label>
  );
}
